// React
import React from 'react';

class BgImg extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className={this.props.class} style={{ backgroundImage: `url(${this.props.bgImg})` }}>
				<div className="degrade-bottom"></div>
				<div className="degrade-left"></div>
			</div>
		);
	}
}

export default BgImg;


// WEBPACK FOOTER //
// ./src/components/core/bgImg.component.jsx